import { makeStyles } from '@mui/styles'

export default makeStyles(() => ({
  image: {
    margin: 'auto',
    width: '45vh',
    minWidth: '300px'
  }
}))
